/**
 * Buffer polyfill for @react-pdf/renderer.
 *
 * @react-pdf/renderer reaches for the Node `Buffer` global on its image and font
 * embedding paths. In a browser bundle that global does not exist, so PDF
 * generation logged `Buffer is not defined` — twice per document, from
 * `pdf(...).toBlob()` — and produced a PDF with the business logo missing.
 *
 * Found on production 2026-08-17 while downloading an invoice: the document was
 * still generated and stored, which is why this read as cosmetic noise rather
 * than the silent image failure it actually was.
 *
 * Imported for side effects only, and imported FIRST in main.tsx so the global is
 * in place before anything can pull in the PDF renderer.
 *
 * Note this is only half the fix: the renderer also fetches an inlined wasm
 * module as a `data:` URL, which the Content-Security-Policy in
 * apps/dashboard/public/serve.json blocked until `data:` was added to
 * `connect-src`. Both are needed for a clean console and a logo on the page.
 */
import { Buffer as BufferPolyfill } from 'buffer';

// Assigned through a cast rather than a `declare global` block: declaring a
// global named Buffer whose type is the imported Buffer makes TypeScript resolve
// the annotation back through itself (TS2502). Nothing in our own code reads the
// global — only @react-pdf/renderer does — so there is no benefit to typing it.
const globalScope = globalThis as unknown as { Buffer?: typeof BufferPolyfill };

if (typeof globalScope.Buffer === 'undefined') {
    globalScope.Buffer = BufferPolyfill;
}

export {};
